"use client";

import { motion, useScroll, useSpring } from "motion/react";

/**
 * Thin red progress bar pinned to the top of the viewport that fills as the
 * visitor scrolls the page. Driven directly by scroll position (no auto-play),
 * so it is left in place even under reduced motion.
 */
export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      aria-hidden="true"
      style={{ scaleX }}
      className="fixed inset-x-0 top-0 z-50 h-0.5 origin-left bg-gradient-to-r from-red-600 via-red-500 to-rose-400 shadow-[0_0_0.75rem_rgba(220,38,38,0.7)]"
    />
  );
}
